"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_POPUP_OPEN = 'payment:popup:open';
exports.EVENT_POPUP_CLOSE = 'payment:popup:close';
var PaymentModule = /** @class */ (function () {
    function PaymentModule(localizeError, linkToWindow, props, eventEmitter) {
        var _this = this;
        this.popupInstance = null;
        this.emit = function (event) {
            if (_this.eventEmitter) {
                _this.eventEmitter.emit(event);
            }
            return _this;
        };
        this.openPaymentInNewTab = function (url, walletId, resolve, reject, chargeResponse) {
            if (_this.windowController.name) {
                console.error('window.name will be override with new name - mainwin');
            }
            _this.windowController.name = 'mainwin';
            _this.windowController.onWalletPaymentCompleted = _this.handlePaymentComplete.bind(_this, walletId, chargeResponse, resolve, reject);
            var height = 608;
            var width = 450;
            var top = typeof screen === 'object' ? screen.height / 2 - height / 2 : 0;
            var left = typeof screen === 'object' ? screen.availLeft + screen.width / 2 - width / 2 : 0;
            if (_this.popupInstance && _this.popupInstance.window && _this.popupInstance.location && _this.popupInstance.location.href) {
                _this.emit(exports.EVENT_POPUP_CLOSE);
                _this.popupInstance.location.href = url;
            }
            else {
                _this.popupInstance = _this.windowController.open(url, '_blank', "location=yes,height=" + height + ",width=" + width + ",scrollbars=yes,status=yes,top=" + top + ",left=" + left);
                var interval_1 = setInterval(function () {
                    if (!_this.popupInstance || _this.popupInstance.closed) {
                        _this.emit(exports.EVENT_POPUP_CLOSE);
                        clearInterval(interval_1);
                    }
                }, 100);
            }
            _this.emit(exports.EVENT_POPUP_OPEN);
        };
        this.openPaymentInCurrentTab = function (url, walletId, opener) {
            if (!_this.windowController || !_this.windowController.location && opener) {
                opener(url);
            }
            else if (_this.windowController.location || (_this.windowController.top && _this.windowController.top.location)) {
                if (_this.windowController.top && _this.windowController.top.location) {
                    _this.windowController.top.location.href = url;
                }
                else {
                    _this.windowController.location.href = url;
                }
            }
            else {
                console.error('No location provided');
            }
        };
        this.cancelPaymentPopup = function () {
            if (_this.popupInstance) {
                _this.popupInstance.close();
                _this.popupInstance = null;
            }
        };
        this.launchPaymentPopup = function (walletId, _a) {
            var chargeResponse = _a.chargeResponse;
            var redirectUrl = (chargeResponse && chargeResponse.redirectUrl) || 'about:blank';
            _this.openPaymentInNewTab(redirectUrl, walletId, null, null, chargeResponse);
        };
        this.continuePayment = function (method, _a) {
            var chargeResponse = _a.chargeResponse, inNewTab = _a.inNewTab;
            return (new Promise(function (resolve, reject) {
                if (_this.onPaymentStart) {
                    _this.onPaymentStart(method, { type: 'PAYMENT_START' });
                }
                var result = _this.preparePaymentCompleteResult(method, chargeResponse);
                if (['APPROVED', 'PENDING_MERCHANT', 'PENDING_BUYER', 'INITIALIZED', 'OFFLINE'].indexOf(chargeResponse.transactionStatus) !== -1) {
                    if (_this.onPaymentComplete) {
                        _this.onPaymentComplete(method, result);
                    }
                    resolve(result);
                }
                if (['IN_PROCESS', 'INITIALIZATION'].indexOf(chargeResponse.transactionStatus) !== -1) {
                    if (inNewTab) {
                        _this.openPaymentInNewTab(chargeResponse.redirectUrl, method, resolve, reject, chargeResponse);
                    }
                    else {
                        resolve(result);
                        _this.openPaymentInCurrentTab(chargeResponse.redirectUrl, method, _this.linkOpener);
                    }
                }
                if (['UNDEFINED', 'DECLINED', 'FAILED', 'BUYER_CANCELED', 'TIMEOUT'].indexOf(chargeResponse.transactionStatus) !== -1) {
                    _this.cancelPaymentPopup();
                    _this.localizeError(chargeResponse.failureDetails).then(function (translatedError) {
                        var rejectResult = __assign({}, result, { errorCode: chargeResponse.failureDetails, translatedError: translatedError });
                        if (_this.onPaymentComplete) {
                            _this.onPaymentComplete(method, rejectResult);
                        }
                        reject(rejectResult);
                    });
                }
            }));
        };
        this.eventEmitter = eventEmitter;
        this.windowController = linkToWindow || window;
        this.localizeError = localizeError;
        this.onPaymentComplete = props.onPaymentComplete;
        this.onPaymentStart = props.onPaymentStart;
        this.linkOpener = props.linkOpener;
    }
    PaymentModule.prototype.handlePaymentComplete = function (walletId, chargeResponse, resolve, reject, result) {
        if (result === void 0) { result = { status: '', errorCode: '' }; }
        this.popupInstance = null;
        var OK_STATUSES = ['APPROVED', 'PENDING_MERCHANT', 'PENDING_BUYER'];
        var paymentResult = this.preparePaymentCompleteResult(walletId, chargeResponse, result);
        if (resolve && OK_STATUSES.indexOf(result.status) !== -1) {
            resolve(paymentResult);
        }
        else if (reject && this.localizeError) {
            this.localizeError(result.errorCode).then(function (translatedError) {
                return reject(__assign({}, paymentResult, { translatedError: translatedError }));
            });
        }
        if (this.onPaymentComplete) {
            this.onPaymentComplete(walletId, paymentResult);
        }
    };
    PaymentModule.prototype.preparePaymentCompleteResult = function (method, chargeResponse, result) {
        if (result === void 0) { result = {}; }
        return __assign({ status: chargeResponse.transactionStatus, paymentMethod: method, errorCode: '', translatedError: '' }, chargeResponse.chargeId ? { chargeId: chargeResponse.chargeId } : {}, result);
    };
    return PaymentModule;
}());
exports.default = PaymentModule;
//# sourceMappingURL=PaymentModule.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/modules/web/PaymentModule.js
// module id = 422
// module chunks = 0 1